export const dashboard = {
  chooseGame: 'აირჩიე<accent> შენი</accent> თამაში',
  chests: {
    title: 'ითამაშე.<br /><accent>ყოველ</accent> დღე.',
    wording: 'ითამაშე ზედიზედ — ბონუსები უფრო ძლიერი გახდება!',
    dayLabel: 'დღე {{day}}',
    rewardEmpty: 'სამწუხაროდ, ამჯერად არ გაგიმართლა.\nხვალ კიდევ სცადე.',
    rewardAchievementFallback: 'მიღწევა',
    loadError: 'დღიური ჯილდოები ვერ ჩაიტვირთა. სცადე თავიდან.',
    openError: 'სკივრი ვერ გაიხსნა. სცადე თავიდან.',
    retry: 'თავიდან ცდა',
  },
  leaderboard: {
    title: 'ლიდერბორდები',
    period: {
      today: 'დღეს',
      week: 'კვირა',
      month: 'თვე',
      all: 'ყველა',
    },
    tables: {
      chestsOpened: {
        title: 'გახსნილი სკივრები',
        empty: 'სერიები ვერ მოიძებნა',
        name: 'სახელი',
        days: 'დღე',
      },
      gamesPlayed: {
        title: 'თამაში',
        empty: 'თამაშები ვერ მოიძებნა',
        name: 'სახელი',
        games: 'რაოდ.',
      },
      prizeWon: {
        title: 'მოგებული პრიზი',
        empty: 'პრიზები ვერ მოიძებნა',
        name: 'სახელი',
        prize: 'პრიზი',
      },
    },
  },
};
